module.exports = __webpack_public_path__ + "img/tp-101-3.dedbd735.png";